




































import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { lazyInject } from '@/app/container';
import { TermsByLetterAndTopic, TermService, TermServiceSymbol } from '@/app/term/term-service';
import { Term } from '@/app/shared/models';
import aspectStoreModule from '@/app/aspect/apsect-state';
import StoreComponent from '@/app/shared/components/store-component.vue';
import UiDefinitionBoxComponent from '@/app/shared/components/ui/ui-definition-box-component.vue';
import i18n from '@/plugins/i18n';
import { TranslateResult } from 'vue-i18n';

@Component({
  components: {
    StoreComponent,
    UiDefinitionBoxComponent
  }
})
export default class TermsComponent extends Vue {
  @Prop()
  public open: boolean;

  @Prop()
  public allTerms: TermsByLetterAndTopic;

  @lazyInject(TermServiceSymbol)
  private termService: TermService;

  private filteredTermsInternal: TermsByLetterAndTopic|null = null;

  private activeFilterOptionInternal: string = '';

  public get filterOptions(): string[] {
    return Object.keys(this.filteredOnes);
  }

  public get activeFilterOption(): string {
    if (this.activeFilterOptionInternal === '' && this.filterOptions.length > 0) {
      this.activeFilterOptionInternal = this.filterOptions[0];
    }

    return this.activeFilterOptionInternal;
  }

  public set activeFilterOption(value: string) {
    this.activeFilterOptionInternal = value;
  }

  public get definitions(): {[topicId: string]: Term[]} {
    if (this.activeFilterOption === '') {
      return {};
    }

    const keys: string[] = Object.keys(this.filteredOnes);
    if (keys.length === 0) {
      return {};
    }

    if (!this.filteredOnes[this.activeFilterOption]) {
      this.activeFilterOption = keys[0];
    }

    return this.filteredOnes[this.activeFilterOption];
  }

  public get filterCount(): number {
    return Object.keys(this.filteredOnes).reduce((totalCount, letter) => {
      return Object.keys(this.filteredOnes[letter]).reduce((count, topicId) => {
        return count + (this.filteredOnes[letter][topicId]).length;
      }, totalCount);
    }, 0);
  }

  private get filteredOnes(): TermsByLetterAndTopic {
    if (!this.filteredTermsInternal) {
      return this.allTerms;
    }

    return this.filteredTermsInternal;
  }

  private set filteredOnes(value: TermsByLetterAndTopic) {
    this.filteredTermsInternal = value;
  }

  private get aspectTerms(): Term[] {
    if (!aspectStoreModule.selectedCourseAspectInstance) {
      return [];
    }

    return aspectStoreModule.selectedCourseAspectInstance.terms;
  }

  public mounted(): void {
    this.activeFilterOption = this.filterOptions.length === 0 ? '' : this.filterOptions[0];
  }

  @Watch('open')
  public onOpenChanged(newValue: boolean): void {
    if (!newValue) {
      this.setDefaultState();
    }
  }

  @Emit('closeModal')
  public emitCloseModal(): void {
    this.setDefaultState();
  }

  public sortTerms(terms: Term[]): Term[] {
    return [...terms].sort((a, b) => a.title.localeCompare(b.title));
  }

  public filter(search: string): void {
    if (search === '') {
      this.filteredOnes = this.allTerms;
    } else {
      this.filteredOnes = this.termService.termsByLetterAndTopicId(this.aspectTerms, search);
    }
  }

  public t(key: string): TranslateResult {
    return i18n.t(key);
  }

  private setDefaultState(): void {
    this.filter('');

    this.activeFilterOption = this.filterOptions.length === 0 ? '' : this.filterOptions[0];
  }
}
